import { GiftItemStatus, IGiftItemResponse } from '../types/itemTypes'

const detailsAndTerms = {
  details:
    'The gift voucher styling is designed around you and your brand. The colour and formatting of the text, as well as two solid blocks of colour can be adjusted to match your colour scheme exactly. Here is some more text to make this a bit longer for testing purposes',
  terms:
    'Our in-house designer can create a bespoke header for you, or you can supply your own. All of the text is fully editable for each gift offered. Postal vouchers are printed on high quality paper with a superior print finish and dispatched on your behalf. E-mail vouchers are sent as a printable PDF.',
}

const testGiftVoucherItems: IGiftItemResponse[] = [
  {
    imageUrl:
      'https://admin.one-tree.net//uploads/gift-item-image/medium/32c71bc6513bc7af60d9648a11af94e4.jpg',
    status: GiftItemStatus.Unpublished,
    id: 139,
    name: 'ONLY IN ROYAL',
    validity: 24,
    description: '<p>This</p> <p></p> <p>gift voucher',
    type: 'Monetary',
    value:
      '10,15,20,25,30,35,40,45,50,60,70,80,90,100,130,150,175,200,250,300,350,400,450',
    order: 1,
    categoryIds: [117, 119, 121, 122, 123, 124, 125, 126, 127],
    ...detailsAndTerms,
  },
  {
    imageUrl:
      'https://admin.one-tree.net//uploads/gift-item-image/medium/fd51bdb7bc3e2a2cd843c55c56ba4a96.jpg',
    status: GiftItemStatus.Published,
    id: 839,
    name: 'IN BOTH ROYAL AND VICTORIA',
    validity: 24,
    maxIndividuals: 8,
    description: '<p>This</p> <p></p> <p>gift voucher &#163;',
    value:
      '500, 550, 600, 650,700,750,800,850,900,950,1000, 1250, 1500, 1750, 2000, 2500',
    order: 2,
    categoryIds: [117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127],
    ...detailsAndTerms,
  },
  {
    imageUrl:
      'https://admin.one-tree.net//uploads/gift-item-image/medium/c86aa821775be19d79e325e455814266.jpg',
    status: GiftItemStatus.Published,
    id: 5599,
    name: 'TEST Cream Tea at the Hotel',
    validity: 12,
    description:
      '<p>Choose a monetary gift voucher which can be used at any Brend Hotel or Restaurant.</p>',
    details:
      '<p>This gift voucher can be exchanged for (or contribute towards) a fine dining experience, luxury accommodation break, or any other service offered at Brend Hotels and Restaurants.</p>\n<p><strong>Test new line</strong></p>\n<p><em>Another</em></p>',
    type: 'Afternoon Tea',
    value: '13',
    order: 3,
    categoryIds: [125],
    maxIndividuals: 6,
    restrictions:
      'This voucher can be redeemed from 2nd January - 28th February 2022. Available daily,  between 2.00pm - 6.00pm Booking is essential. Please call the hotel in advance to check availability and to book.  Vouchers are non-transferable and cannot be exchanged for cash.',
    showOverlay: true,
    overlayImageUrl:
      'https://onetree-files.ams3.digitaloceanspaces.com/item-image/0344b97b87c72f1e8ffb00cb8f26b28d.jpeg',
    terms: 'Some terms',
  },
  {
    imageUrl:
      'https://admin.one-tree.net//uploads/gift-item-image/medium/1de1ee452d2d71954a3aeeb8f7830f8e.jpg',
    status: GiftItemStatus.Published,
    id: 5598,
    name: 'BLACK FRIDAY Overnight Pamper Package (per person)',
    validity: 12,
    description:
      '<p>Afternoon tea for two served in our Comfortable Bar</p><p>This voucher can be redeemed from 2nd January - 28th February 2022. Available daily, between one and two thingies ok thank</p>',
    type: 'Complimentary',
    value: '0',
    order: 4,
    categoryIds: [125],
    ...detailsAndTerms,
  },
]

const testSpecialOfferItems: IGiftItemResponse[] = [
  {
    imageUrl:
      'https://onetree-files.ams3.digitaloceanspaces.com/gift-item-image/8ce8afc36b809c1cf34be70d96a0c731.png',
    headerImageUrl:
      'https://onetree-files.ams3.digitaloceanspaces.com/gift-item-header/0e311f227da2a149dcbfa800a6cbd0f8.png',
    status: GiftItemStatus.Published,
    id: 6406,
    name: '2 Night Winter Break for 2 Bed and Breakfast',
    value: '260',
    order: 1,
    categoryIds: [116],
    quantity: 100,
    quantitySold: 98,
    originalPrice: 300,
    showRemaining: true,
    maxPerOrder: 100,
    startDate: 1600000000,
    expiryDate: 1700000000,
    restrictions:
      'This voucher can be redeemed from 2nd January - 28th February 2022. Available daily,  between 2.00pm - 6.00pm Booking is essential. Please call the hotel in advance to check availability and to book.  Vouchers are non-transferable and cannot be exchanged for cash.',
  },
  {
    imageUrl:
      'https://onetree-files.ams3.digitaloceanspaces.com/gift-item-image/c4e9e89b1c6e7996e25420ba6d71b72b.png',
    headerImageUrl:
      'https://onetree-files.ams3.digitaloceanspaces.com/gift-item-header/63291a094b1f6e8da8837007f07f508e.png',
    status: GiftItemStatus.Published,
    id: 6407,
    name: '2 Night Winter Break for 2 Dinner,Room & Breakfast',
    value: '400',
    order: 2,
    categoryIds: [116],
    quantity: 100,
    quantitySold: 101,
    maxPerOrder: 100,
    showRemaining: true,
  },
  {
    imageUrl:
      'https://onetree-files.ams3.digitaloceanspaces.com/gift-item-image/89cfef9826555d8b0999ad5a6cd89a54.png',
    headerImageUrl:
      'https://onetree-files.ams3.digitaloceanspaces.com/gift-item-header/abc5180e7754fcb5fcf734f9e724e2dc.png',
    status: GiftItemStatus.Published,
    id: 5393,
    name: 'Afternoon Tea With Champagne For Two',
    value: '40',
    order: 3,
    categoryIds: [765],
  },
  {
    imageUrl:
      'https://onetree-files.ams3.digitaloceanspaces.com/gift-item-image/6ebcf6b336808cfbb0df5f4daa91c8ab.jpg',
    headerImageUrl:
      'https://onetree-files.ams3.digitaloceanspaces.com/gift-item-header/b635e3713aa769677faac9d777d2e21c.jpg',
    status: GiftItemStatus.Unpublished,
    id: 2156,
    name: 'DO NOT SELL - OLD VOUCHER!!',
    value: '76',
    order: 4,
    categoryIds: [432],
  },
]

const testTicketItems: IGiftItemResponse[] = [
  {
    imageUrl:
      'https://onetree-files.ams3.digitaloceanspaces.com/item-image/593863d4dd7dd0a6e62e4bbbd27ace88.jpeg',
    headerImageUrl:
      'https://onetree-files.ams3.digitaloceanspaces.com/voucher-banner/710360aa07c7e0b9f2574023546ce87a.jpg',
    status: GiftItemStatus.Unpublished,
    id: 10769,
    name: 'New Years Day ',
    terms:
      '<p>This year we\'re serving up a delicious 3-course lunch menu on New Year\'s Day.</p>\n<p>Enjoy a leisurely day and indulge with family and friends.&nbsp;</p>\n<p><br></p>\n<p>Adults \u00a338.00pp</p>\n<p>Children\'s Menu \u00a314.95pp</p>',
    imageFileId: 18915,
    value: '',
    order: 251,
    quantity: 20,
    headerImageFileId: 12095,
    showOverlay: false,
    quantitySold: 0,
    categoryIds: [1016],
    embedUrl: 'https://admin.one-tree.dev/embeditem-3b11a2fc1b249e29d.js',
    startInfo: 'Thursday 1st January 2026 - 12 noon ',
    enabledQuestionIds: [],
    prices: [
      {
        id: 10911,
        name: 'Adult',
        value: '38.00',
        status: GiftItemStatus.Published,
        enabledQuestionIds: [1351],
        quantitySold: 0,
      },
      {
        id: 10912,
        name: 'Child ',
        value: '14.95',
        status: GiftItemStatus.Published,
        enabledQuestionIds: [1351],
        quantitySold: 0,
      },
    ],
  },
  {
    imageUrl: '',
    headerImageUrl:
      'https://onetree-files.ams3.digitaloceanspaces.com/gift-item-header/87d5ee56c12c0642bd77cdd28b3eac59.jpg',
    status: GiftItemStatus.Published,
    id: 6528,
    name: 'Galentine\'s Afternoon Tea Takeaway - 13th Feb',
    value: '12.95',
    order: 4,
    categoryIds: [434],
    startInfo: 'Saturday 23rd June 2018',
    quantity: 100,
    quantitySold: 12,
    showRemaining: true,
    maxPerOrder: 3,
    prices: [
      {
        id: 9990,
        name: 'A published ticket',
        value: '150.75',
        status: GiftItemStatus.Published,
        enabledQuestionIds: [],
      },
      {
        id: 9991,
        name: 'An unpublished ticket',
        value: '800.50',
        status: GiftItemStatus.Unpublished,
        enabledQuestionIds: [],
      },
      {
        id: 9992,
        name: 'An inactive ticket',
        value: '7.50',
        status: GiftItemStatus.Archived,
        enabledQuestionIds: [],
      },
      {
        id: 9993,
        name: 'Another published ticket',
        value: '5',
        status: GiftItemStatus.Published,
        enabledQuestionIds: [],
      },
    ],
  },
  {
    imageUrl:
      'https://onetree-files.ams3.digitaloceanspaces.com/gift-item-image/6f8b669a2fbd46d567ec5ea4e13bca07.JPG',
    headerImageUrl:
      'https://onetree-files.ams3.digitaloceanspaces.com/gift-item-header/87d5ee56c12c0642bd77cdd28b3eac59.jpg',
    status: GiftItemStatus.Unpublished,
    id: 6536,
    name: 'Valentine\'s Afternoon Tea Takeaway - 14th Feb',
    value: '12.95',
    order: 2,
    categoryIds: [436],
    startInfo: 'Saturday 23rd June 2019',
  },
  {
    imageUrl:
      'https://onetree-files.ams3.digitaloceanspaces.com/gift-item-image/d5e3311fb23bc7fa05dd3f0e46866cbd.JPG',
    headerImageUrl:
      'https://onetree-files.ams3.digitaloceanspaces.com/gift-item-header/87d5ee56c12c0642bd77cdd28b3eac59.jpg',
    status: GiftItemStatus.Unpublished,
    id: 6533,
    name: 'Valentine\'s Day "In a Box" 14th February',
    value: '24.95',
    order: 3,
    categoryIds: [434],
    startInfo: 'Saturday 23rd June 2018',
  },
  {
    imageUrl:
      'https://onetree-files.ams3.digitaloceanspaces.com/gift-item-image/b7693a308ad60a0718c232668b1430f2.jpg',
    headerImageUrl:
      'https://onetree-files.ams3.digitaloceanspaces.com/gift-item-header/d875594421863df5c51b59e2da4617be.jpg',
    status: GiftItemStatus.Published,
    id: 6570,
    name: 'Cocktail Masterclass',
    value: '24.95',
    order: 4,
    categoryIds: [432],
    startInfo: 'Saturday 23rd June 2018',
  },
  {
    imageUrl:
      'https://onetree-files.ams3.digitaloceanspaces.com/gift-item-image/b7693a308ad60a0718c232668b1430f2.jpg',
    headerImageUrl:
      'https://onetree-files.ams3.digitaloceanspaces.com/gift-item-header/d875594421863df5c51b59e2da4617be.jpg',
    status: GiftItemStatus.Unpublished,
    id: 6570,
    name: 'Cocktail Masterclass',
    value: '24.95',
    order: 4,
    categoryIds: [765, 432],
    startInfo: 'Saturday 23rd June 2018',
  },
  {
    categoryIds: [116, 117, 118, 119, 120, 122, 123, 125, 126, 127],
    description:
      '<p>Choose a monetary gift voucher which can be used at any Brend Hotel or Restaurant.</p>',
    details:
      '<p>This gift voucher can be exchanged for (or contribute towards) a fine dining experience, luxury accommodation break, or any other service offered at Brend Hotels and Restaurants.</p>',
    id: 111,
    imageUrl:
      'https://onetree-files.ams3.digitaloceanspaces.com/gift-item-image/fc8c7ef04cbac9686b7de15ac67e5696.png',
    name: 'ONLY IN VICTORIA',
    order: 23,
    status: GiftItemStatus.Published,
    terms:
      '<p>Please visit www.brend-hotels.co.uk, or call&nbsp;01271 340010&nbsp;for further information. Please have your voucher number ready on calling and present it on arrival at your chosen hotel. Change is given provided you spend at least 50% of the voucher face value in a single transaction.</p>',
    type: '5',
    validity: 24,
    value:
      '10,15,20,25,30,35,40,45,50,60,70,80,90,100,130,150,175,200,250,300,350,400,450',
  },
]

// eslint-disable-next-line import/prefer-default-export
export const testItems = [
  ...testGiftVoucherItems,
  ...testSpecialOfferItems,
  ...testTicketItems,
]
